/* eslint-disable max-len */
/* eslint-disable camelcase */
import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import CheckboxComponent from 'components/atoms/CheckboxComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';
import trueFalseSelect from 'data/selectCodes/trueFalseSelect';
import emailValidation from 'enums/validations/emailValidation';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { EStavZadosti, IZadostResp, nzSouhlasApi } from 'services/nezarazenyUcet/nuZapis';
import formatNumber from 'utils/formatNumber';
import phoneValidation from 'utils/validations/phoneValidation';
import ObchodniPodminky from '../ObchodniPodminky';

interface IIDEN {
    zadostData?: IZadostResp;
    contactInfoEmail?: string;
    contactInfoPhone?: string;
    setZadostData?: React.Dispatch<React.SetStateAction<IZadostResp | undefined>>;
    setContactInfoEmail?: React.Dispatch<React.SetStateAction<string | undefined>>;
}

const IDEN: React.FC<IIDEN> = props => {
    const banky = [
        {
            id: '297d3f16-c4c0-4f48-8d98-c94d16eb9e35',
            title: 'Air Bank',
            description: null,
            available_logo_images: [
                {
                    id: '4cff4db9-adc4-499a-b698-c186fb14df49',
                    url:
                        'https://img.bankid.cz/GjFzHXjQhWvhEx2HFdHhnIq8bVkbA3R4XRULujuBFzo/fit/1024/1024/no/1/czM6Ly9maWxlc2VydmljZS80Y2ZmNGRiOS1hZGM0LTQ5OWEtYjY5OC1jMTg2ZmIxNGRmNDkucG5n',
                    width: 1025,
                    height: 1025
                }
            ],
            available_services: ['AUTHENTICATION', 'SIGN_SINGLE_PDF', 'SIGN_SO']
        },
        {
            id: '1aebb93d-3643-46eb-a6cf-a1760e02a810',
            title: 'Fio Banka a.s.',
            description: null,
            available_logo_images: [
                {
                    id: 'f0525f4f-0192-4ff0-89d2-ca3a0df863f8',
                    url:
                        'https://img.bankid.cz/fV7STqizoPfYVtGj3BPJyvuRFUXnwwyFwGfaHUM1ipo/fit/1024/1024/no/1/czM6Ly9maWxlc2VydmljZS9mMDUyNWY0Zi0wMTkyLTRmZjAtODlkMi1jYTNhMGRmODYzZjgucG5n',
                    width: 1024,
                    height: 1024
                }
            ],
            available_services: ['AUTHENTICATION']
        },
        {
            id: '3b42a926-7d02-472b-bd22-f12fdf22bf0f',
            title: 'Komerční banka',
            description: 'Komerční banka',
            available_logo_images: [
                {
                    id: '57077c2f-9e72-4365-b23e-659f8b33b1b5',
                    url:
                        'https://img.bankid.cz/G99x7ZdNkYF_IULmgstvGhZjbETwb8UNjS9j1Ox4cdk/fit/1024/1024/no/1/czM6Ly9maWxlc2VydmljZS81NzA3N2MyZi05ZTcyLTQzNjUtYjIzZS02NTlmOGIzM2IxYjUucG5n',
                    width: 1024,
                    height: 1024
                }
            ],
            available_services: [
                'NOTIFICATION',
                'SIGN_SO',
                'SIGN_MULTIPLE_PDF',
                'AUTHENTICATION',
                'SIGN_SINGLE_PDF',
                'UNIQUE_IDENTITY'
            ]
        },
        {
            id: 'bd86df8c-56a0-4d0b-b7f6-bcff83fa09de',
            title: 'MONETA',
            description: null,
            available_logo_images: [
                {
                    id: '5702ae1a-8517-4fb8-a79d-61682e1b839b',
                    url:
                        'https://img.bankid.cz/xpdBzR8AM9r_xBPG3vw3228l6hKGpLb9r6D6HXTzLNo/fit/1024/1024/no/1/czM6Ly9maWxlc2VydmljZS81NzAyYWUxYS04NTE3LTRmYjgtYTc5ZC02MTY4MmUxYjgzOWIucG5n',
                    width: 1024,
                    height: 1024
                }
            ],
            available_services: ['AUTHENTICATION', 'SIGN_SINGLE_PDF', 'SIGN_SO', 'NOTIFICATION', 'SIGN_MULTIPLE_PDF']
        },
        {
            id: '297c962c-6c1c-4758-81bd-93191ca62749',
            title: 'Raiffeisenbank a.s.',
            description: null,
            available_logo_images: [
                {
                    id: '87ccfd4a-6ae3-4eb4-91c2-561d95ea9d86',
                    url:
                        'https://img.bankid.cz/zYswip7VC-xjD0SF8XeQ772YBi4q5I3FfR5G4ist6As/fit/1024/1024/no/1/czM6Ly9maWxlc2VydmljZS84N2NjZmQ0YS02YWUzLTRlYjQtOTFjMi01NjFkOTVlYTlkODYucG5n',
                    width: 1024,
                    height: 1024
                }
            ],
            available_services: ['AUTHENTICATION', 'SIGN_SINGLE_PDF', 'SIGN_SO', 'NOTIFICATION']
        },
        {
            id: '032051de-f43d-4cb8-a911-2ef03773a3b4',
            title: 'ČSOB a.s.',
            description: null,
            available_logo_images: [
                {
                    id: '0c13079d-e293-4fe3-b792-08a30e74e30d',
                    url:
                        'https://img.bankid.cz/wal-WnJrnnLyq_dpXOKz86XA24LGBlmlDzqjzD3anXo/fit/1024/1024/no/1/czM6Ly9maWxlc2VydmljZS8wYzEzMDc5ZC1lMjkzLTRmZTMtYjc5Mi0wOGEzMGU3NGUzMGQucG5n',
                    width: 1024,
                    height: 1024
                }
            ],
            available_services: ['NOTIFICATION', 'AUTHENTICATION', 'SIGN_SINGLE_PDF', 'SIGN_MULTIPLE_PDF', 'SIGN_SO']
        },
        {
            id: '7e623fed-8aab-4d24-9918-c610d3057859',
            title: 'Česká spořitelna',
            description: 'CSAS',
            available_logo_images: [
                {
                    id: '495f7317-c3b9-43da-8281-9dd3699369a0',
                    url:
                        'https://img.bankid.cz/0b-kahJ943j2ccbFJ4fzhktMzer45ryOjFcQaf5XjEw/fit/1024/1024/no/1/czM6Ly9maWxlc2VydmljZS80OTVmNzMxNy1jM2I5LTQzZGEtODI4MS05ZGQzNjk5MzY5YTAucG5n',
                    width: 1024,
                    height: 1024
                }
            ],
            available_services: ['AUTHENTICATION', 'SIGN_SINGLE_PDF', 'SIGN_SO', 'NOTIFICATION', 'SIGN_MULTIPLE_PDF']
        }
    ];

    const [form] = useForm();
    const { zadostData, contactInfoEmail, contactInfoPhone, setZadostData } = props;
    const history = useHistory();
    const [errStatus, setErrStatus] = useState<number>();
    const [showTerms, setShowTerms] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [, setRerender] = useState<boolean>(false);
    const [showDeclaration, setShowDeclaration] = useState<boolean>(false);
    const { token } = useParams<{ token: string }>();

    const routeChange = () => {
        let path = zadostData?.zadostid
            ? '/nezarazeny-ucet-zapis/idzadost/' + zadostData.zadostid
            : '/nezarazeny-ucet-zapis/idzadost/';
        history.push(path);
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        if (!showDeclaration) {
            setShowDeclaration(true);
        } else {
            setLoading(true);
            nzSouhlasApi(
                {
                    email: fieldsValue.email,
                    telefon: fieldsValue.telefon.split(' ').join('')
                },
                token
            )
                .then(() => {
                    setZadostData &&
                        setZadostData(pv =>
                            pv
                                ? {
                                      ...pv,
                                      email: fieldsValue.email,
                                      telefon: fieldsValue.telefon,
                                      stav: EStavZadosti.SOUHL
                                  }
                                : {
                                      email: fieldsValue.email,
                                      telefon: fieldsValue.telefon,
                                      stav: EStavZadosti.SOUHL
                                  }
                        );
                })
                .catch((err: AxiosError) => {
                    setErrStatus(err.response?.status);
                })
                .finally(() => setLoading(false));
        }
    };

    return (
        <LoadingWrapper loading={loading}>
            {errStatus ? (
                <Col span={24}>
                    <Row>
                        {errStatus === 400 ? (
                            <Title text="RESPONSE_ERROR_400" level={3} />
                        ) : errStatus === 401 ? (
                            <Title text="RESPONSE_ERROR_401" level={3} />
                        ) : errStatus === 404 ? (
                            <Title text="RESPONSE_ERROR_404" level={3} />
                        ) : errStatus === 500 ? (
                            <Title text="RESPONSE_ERROR_500" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                    </Row>
                </Col>
            ) : showTerms ? (
                <>
                    <ObchodniPodminky setShowTerms={setShowTerms} />
                </>
            ) : (
                <FormWrapper
                    onFinish={onFinish}
                    requiredMark={false}
                    colon={false}
                    outForm={form}
                    size="small"
                    labelAlign="left"
                    layoutPosition="horizontal"
                >
                    {/* <Paragraph text="KROKY_PRO_ZISKANI_VYSTUPU" strong={true} /> */}
                    <h3>
                        <TranslateText>Popis služby</TranslateText>
                    </h3>
                    <Paragraph text="Služba umožňuje majiteli nezařazeného účtu aktualizovat osobní či adresní údaje a zapsat nebo změnit číslo bankovního účtu pro účely výplat výnosů." />
                    <SelectComponent
                        labelCol={{
                            span: 24
                        }}
                        labelParagraph="Potvrzuji, že znám číslo svého majetkového účtu v nezařazené evidenci. "
                        isFormItem={true}
                        name="potvrzeni"
                        data={trueFalseSelect}
                        onChange={() => setRerender(pv => !pv)}
                        disabled={showDeclaration}
                        rules={[
                            {
                                required: true,
                                message: <TranslateText>{'NEVALIDNI_POVINNA_POLOZKA'}</TranslateText>
                            }
                        ]}
                    />
                    {!showDeclaration ? (
                        form.getFieldValue('potvrzeni') && form.getFieldValue('potvrzeni') === 'false' ? (
                            <>
                                <Paragraph text="Číslo Vašeho majetkového účtu budete potřebovat pro dokončení žádosti o Zápis změny údajů evidovaných na Vašem nezařazeném účtu. V případě, že neznáte číslo Vašeho nezařazeného majetkového účtu, pokračujte stisknutím tlačítka „Výpis z nezařazeného účtu online" />
                                <Row className="statement-buttons-row">
                                    <ButtonComponent
                                        buttontext="Výpis z nezařazeného účtu online"
                                        onClick={() => window.open('/nezarazeny-ucet-bankid/', '_parent')}
                                    />
                                </Row>
                            </>
                        ) : (
                            <Row className="statement-buttons-row">
                                <ButtonComponent htmlType="submit" buttontext="POKRACOVAT" />
                            </Row>
                        )
                    ) : (
                        <>
                            <Paragraph text="POPIS_SLUBY_TEXT_NZ" />

                            <h3>
                                <TranslateText>Prohlášení</TranslateText>
                            </h3>

                            <CheckboxComponent
                                name="souhlas1"
                                checkboxText={
                                    <>
                                        <TranslateText>
                                            Potvrzuji, že znám číslo svého majetkového účtu v nezařazené evidenci.
                                        </TranslateText>
                                    </>
                                }
                            />
                            <CheckboxComponent
                                name="souhlas2"
                                checkboxText={
                                    <>
                                        <TranslateText>
                                            Potvrzuji, že jsem majitelem nezařazeného účtu, u kterého žádám o zápis
                                            změny evidovaných údajů.
                                        </TranslateText>
                                    </>
                                }
                            />
                            <CheckboxComponent
                                name="souhlas3"
                                checkboxText={
                                    <>
                                        <TranslateText>
                                            Souhlasím s identifikací prostřednictvím bankovní identity a jsem si vědom
                                            toho, že ne všechny banky
                                        </TranslateText>
                                    </>
                                }
                            />
                            <p>
                                poskytují prostřednictvím <a href="https://www.bankid.cz/">bankovní identity </a>
                                identifikační služby vůči soukromým subjektům.
                                <br />
                                Souhlasím s poskytnutím svého rodného čísla za účelem zpracování služby.
                            </p>
                            <Paragraph
                                text="Ověření žadatele prostřednictvím Bankovní identity je možné pro banky"
                                style={{
                                    fontWeight: 'bold'
                                }}
                            />
                            <Row
                                style={{
                                    width: 420
                                }}
                            >
                                {banky.map(e => (
                                    <Col
                                        span={7}
                                        style={{
                                            margin: 4,
                                            padding: 10,
                                            backgroundColor: 'white',
                                            boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
                                        }}
                                    >
                                        <img src={e.available_logo_images[0].url} alt={e.title} width={100} />
                                    </Col>
                                ))}
                            </Row>
                            <Row>
                                <CheckboxComponent
                                    name="souhlas4"
                                    checkboxText={
                                        <>
                                            <Paragraph
                                                // eslint-disable-next-line max-len
                                                text="Beru na vědomí, že po zaplacení poplatku za službu nemám nárok na jeho vrácení v případě nesplnění podmínek služby (zejména neposkytnutí identifikace způsobilou bankovní identitou, neposkytnutí rodného čísla, neposkytnutí čísla nezařazeného účtu, apod)"
                                            />
                                        </>
                                    }
                                />
                            </Row>
                            {/* <Paragraph
                                text="Centrální depozitář poskytuje výpis z nezařazeného majetkového účtu cenných papírů online službou,
                             která je dostupná na internetových stránkách centrálního depozitáře všem osobám, které se identifikují prostřednictvím bankovní
                              identity. Poplatek za výpis online činí 90 Kč. Žádost o službu lze podat i korespondenčním způsobem prostřednictvím formuláře Žádost o výpis
                               z nezařazeného majetkového účtu cenných papírů opatřeného úředně ověřeným podpisem. Aktuální poplatek za výpis z účtu doručený na dobírku je 500 Kč.
Podrobné informace naleznete na webové stránce "
                            />
                            <a href="https://www.cdcp.cz/siroka-verejnost/sluzby-pro-sirokou-verejnost/">
                                Služby pro širokou veřejnost
                                </a> */}
                            <h3>
                                <TranslateText>Zadejte kontaktní údaje</TranslateText>
                            </h3>

                            <InputComponent
                                label="EMAIL"
                                name="email"
                                rules={emailValidation('NEVALIDNI_POVINNA_POLOZKA')}
                                initialValue={
                                    zadostData?.email ? zadostData.email : contactInfoEmail ?? contactInfoEmail!
                                }
                            />
                            <InputComponent
                                label="PHONE_NUMBER"
                                name="telefon"
                                // disabled={true}
                                rules={phoneValidation('NEVALIDNI_POVINNA_POLOZKA')}
                                initialValue={
                                    zadostData?.telefon
                                        ? formatNumber(zadostData.telefon)
                                        : formatNumber(contactInfoPhone)
                                }
                            />
                            <Row>
                                <CheckboxComponent
                                    name="souhlas5"
                                    checkboxText={
                                        <>
                                            <TranslateText>SOUHLASIM_S</TranslateText>{' '}
                                            <a
                                                onClick={() => {
                                                    const fieldsValue = form.getFieldsValue();
                                                    setZadostData &&
                                                        setZadostData(pv => {
                                                            return {
                                                                ...pv,
                                                                zadostid: pv?.zadostid || '0',
                                                                email: fieldsValue.email,
                                                                telefon: fieldsValue.phone
                                                            };
                                                        });
                                                    setShowTerms(true);
                                                }}
                                                style={{
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                <TranslateText>PODMINKAMI_SLUZBY</TranslateText>
                                            </a>{' '}
                                            <TranslateText>
                                                Zápis údajů do nezařazené evidence k aktuálnímu datu.
                                            </TranslateText>
                                        </>
                                    }
                                />
                            </Row>

                            <Row className="statement-buttons-row">
                                <ButtonComponent htmlType="submit" buttontext="POTVRDIT_A_ODESLAT" />
                            </Row>
                        </>
                    )}
                </FormWrapper>
            )}
        </LoadingWrapper>
    );
};

export default IDEN;
